<template>
  <div :class="classnames">
    <popup @openchange="handlePopupOpenChange">
      <template slot="control">
        <interactive-svg-icon :isActive="isPopupOpen">
          <svg-icon-more height="4" width="18" />
        </interactive-svg-icon>
      </template>

      <template slot="content">
        <ul v-for="(list, index) in lists" :class="`${ns}__list`" :key="index">
          <li v-for="(item, index) in list" :class="`${ns}__list-item`" :key="index">
            <template v-if="item.share">
              <OpenModalControl  :view="'modal-view-share'" :props="item.share">
                <span :class="`${ns}__link`">{{ item.text }}</span>
              </OpenModalControl>
            </template>
            <template v-else>
              <a v-if="item.url" :class="`${ns}__link`" :href="item.url" :target="setTarget(item)">
                {{ item.text }}
              </a>
            </template>
          </li>
        </ul>
      </template>
    </popup>
  </div>
</template>

<script>
  import InteractiveSvgIcon from '@/components/InteractiveSvgIcon'
  import OpenModalControl from '@/components/OpenModalControl'
  import Popup from '@/components/Popup/Popup'

  import SvgIconMore from '@/svgs/SvgIconMore'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'toolbar-more-menu'

  // const isExternalLink = (url) => {
  //   return url.toLowerCase().indexOf('http') !== -1
  // }

  export default {
    name: 'ToolbarMoreMenu',
    components: {
      OpenModalControl,
      'interactive-svg-icon': InteractiveSvgIcon,
      'popup': Popup,
      'svg-icon-more': SvgIconMore
    },
    mixins: [ bem ],
    props: {
      lists: {
        type: Array
      }
    },
    data: function () {
      return {
        isPopupOpen: false
      }
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      handlePopupOpenChange: function (isPopupOpen) {
        this.isPopupOpen = isPopupOpen
      },
      setTarget: function (link) {
        const {
          target
        } = link

        const linkTarget = target || '_self'

        return linkTarget
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ToolbarMoreMenu.vue